module.exports = __webpack_public_path__ + "img/wxShareArrowIcon.5dedbde9.png";